const STORAGE_KEY = "dtx_file_clipboard";
const CHANNEL_NAME = "dtx_file_clipboard_channel";
let copiedItems = [];
let isCut = false;
let renamingPath = null;
let tempRenameValue = "";
let renamingSource = null;
const listeners = /* @__PURE__ */ new Set();
try {
  if (typeof localStorage !== "undefined") {
    const saved = localStorage.getItem(STORAGE_KEY);
    if (saved) {
      const parsed = JSON.parse(saved);
      if (Array.isArray(parsed.copiedItems)) {
        copiedItems = parsed.copiedItems;
        isCut = !!parsed.isCut;
      }
    }
  }
} catch (e) {
}
const notify = () => {
  listeners.forEach((listener) => listener({
    copiedItems,
    isCut,
    renamingPath,
    tempRenameValue,
    renamingSource
  }));
};
let broadcastChannel = null;
try {
  if (typeof BroadcastChannel !== "undefined") {
    broadcastChannel = new BroadcastChannel(CHANNEL_NAME);
    broadcastChannel.onmessage = (e) => {
      if (e.data && Array.isArray(e.data.copiedItems)) {
        copiedItems = e.data.copiedItems;
        isCut = !!e.data.isCut;
        notify();
      }
    };
  }
} catch (e) {
}
if (typeof window !== "undefined") {
  window.addEventListener("storage", (e) => {
    if (e.key === STORAGE_KEY && e.newValue) {
      try {
        const parsed = JSON.parse(e.newValue);
        if (Array.isArray(parsed.copiedItems)) {
          copiedItems = parsed.copiedItems;
          isCut = !!parsed.isCut;
          notify();
        }
      } catch (err) {
      }
    }
  });
}
export const writeFilesToSystemClipboard = async (items, cut = false) => {
  if (!items || items.length === 0) return;
  const names = items.map((i) => i.name).join("\n");
  const payload = JSON.stringify({
    type: "dtx_file_clipboard",
    copiedItems: items,
    isCut: !!cut,
    timestamp: Date.now()
  });
  try {
    if (typeof ClipboardItem !== "undefined" && navigator.clipboard?.write) {
      const textBlob = new Blob([names], { type: "text/plain" });
      const jsonBlob = new Blob([payload], { type: "application/json" });
      await navigator.clipboard.write([
        new ClipboardItem({
          "text/plain": textBlob,
          "application/json": jsonBlob
        })
      ]);
      return;
    }
  } catch (err) {
  }
  try {
    if (navigator.clipboard?.writeText) {
      await navigator.clipboard.writeText(names);
    }
  } catch (err) {
  }
};
export const getFileClipboard = () => ({
  copiedItems,
  isCut,
  renamingPath,
  tempRenameValue,
  renamingSource
});
export const setFileClipboard = (items, cut = false) => {
  console.log("[fileClipboard] setFileClipboard:", {
    count: items?.length,
    isCut: cut,
    items: items?.map((i) => ({ name: i.name, path: i.path }))
  });
  copiedItems = items || [];
  isCut = cut;
  try {
    if (typeof localStorage !== "undefined") {
      localStorage.setItem(STORAGE_KEY, JSON.stringify({
        copiedItems,
        isCut,
        timestamp: Date.now()
      }));
    }
  } catch (e) {
  }
  try {
    if (broadcastChannel) {
      broadcastChannel.postMessage({
        copiedItems,
        isCut,
        timestamp: Date.now()
      });
    }
  } catch (e) {
  }
  writeFilesToSystemClipboard(copiedItems, isCut);
  notify();
};
export const setRenamingState = (path, value = "", source = null) => {
  renamingPath = path;
  tempRenameValue = value;
  renamingSource = source;
  notify();
};
export const subscribeToFileClipboard = (listener) => {
  listeners.add(listener);
  return () => listeners.delete(listener);
};
let activeTableSelection = { selectedPaths: [], lastClickedPath: null, folderPath: "." };
export const getActiveTableSelection = () => activeTableSelection;
export const setActiveTableSelection = (selection) => {
  activeTableSelection = {
    ...activeTableSelection,
    ...selection
  };
};
